import { render, staticRenderFns } from "./T.vue?vue&type=template&id=142d20b8&scoped=true&"
import script from "./T.vue?vue&type=script&lang=js&"
export * from "./T.vue?vue&type=script&lang=js&"
import style0 from "./T.vue?vue&type=style&index=0&id=142d20b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142d20b8",
  null
  
)

export default component.exports